var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"id":"gfs:icon1/play","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M10.24 19.52l9.41-7.6-9.41-7.61A1.37 1.37 0 008 5.38v13.07a1.37 1.37 0 002.24 1.07zm6.63-7.6l-7.12 5.75V6.16l7.12 5.75z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }